import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function CheckboxLabels({ Label, check, onClick, name }) {
    return (
        <FormGroup sx={{ marginTop: "10px" }}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={check}
                        style={{
                            color: check ? '#448aff' : undefined,
                            "& .MuiButtonBaseRoot": {
                                marginRight: '5px'
                            },
                            marginRight: '5px'

                        }}
                    />
                }
                label={Label}
                name={name}
                onClick={onClick}
            />
        </FormGroup>
    );
}
